import { html, LitElement } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import { getTeacherNotesData } from "../../data/classroom";
import { styles } from "./teacher-notes.styles";

import type { PropertyValues } from "lit";
import type { TeacherNoteData } from "../../types.d";

@customElement("bp-teacher-notes")
export class TeacherNotes extends LitElement {
  static styles = styles;

  @property({ attribute: "arc-id" })
  arcId?: string;

  @state()
  data?: TeacherNoteData;

  scrollToSlideAnchor(id: string) {
    this.shadowRoot?.querySelector(`[slide-id="${id}"]`)?.scrollIntoView();
  }

  updated(changedProperties: PropertyValues) {
    if (!changedProperties.has("arcId") || !this.arcId) return;

    getTeacherNotesData(this.arcId)
      .then(async ({ data }) => {
        this.data = data;
        this.updateDOMNodes();
      })
      .catch(() => undefined);
  }

  handleLinkClick(e: MouseEvent) {
    if (globalThis.window.BibleProjectApp) e.preventDefault();

    document.dispatchEvent(
      new CustomEvent("bp:external_link", {
        detail: {
          href: (e.currentTarget as HTMLAnchorElement).href,
        },
      }),
    );
  }

  async updateDOMNodes() {
    await this.updateComplete;

    // Ensure all links are treated as "external"
    this.shadowRoot?.querySelectorAll("a").forEach((e) => {
      e.setAttribute("target", "_blank");
      e.removeEventListener("click", this.handleLinkClick);
      e.addEventListener("click", this.handleLinkClick);
    });
  }

  render() {
    if (!this.data) return html`<bp-spinner size="lg"></bp-spinner>`;

    return unsafeHTML(this.data.contentHtml);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-teacher-notes": TeacherNotes;
  }
}
